import React from "react";
import "../../css/NotificacionTip.css";
import campana from "../../assets/Campana.svg";

const NotificacionTip = ({ mensaje }) => {
  return (
    <div className="notificacion-tip">
      <span className="notificacion-icono">
        <img src={campana} alt="icono notificación" />
      </span>
      <p className="notificacion-texto">{mensaje}</p>
    </div>
  );
};

export default NotificacionTip;
